let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c8sAv")).then(() => parcelRequire('dxhN5'));